import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const Liability = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Liabilities</h3>
      <p>
        Yoda Safety Services provides its platform, including the training
        portal, courses, quizzes, newsletters, and other services, on an
        &quot;as is&quot; and &quot;as available&quot; basis. We make no
        warranties or representations, express or implied, regarding the
        accuracy, reliability, or availability of our platform.
      </p>
      <h4>Specific Disclaimers</h4>
      <ul>
        <li>
          <strong>Training Portal and Courses:</strong> We are not liable for
          outdated or inaccurate course content. Users are responsible for
          verifying the applicability of the information provided.
        </li>
        <li>
          <strong>Quizzes and Assessments:</strong> Quiz results are for
          informational purposes only and do not guarantee specific outcomes or
          certifications.
        </li>
        <li>
          <strong>Payments:</strong> We are not responsible for errors or issues
          arising from third-party payment processors, such as PayPal.
        </li>
        <li>
          <strong>User Accounts:</strong> Users are responsible for maintaining
          the confidentiality of their account credentials. We are not liable
          for unauthorized access to user accounts.
        </li>
        <li>
          <strong>Company Accounts:</strong> We are not responsible for any
          misuse of company accounts by employees or third parties.
        </li>
      </ul>
      <h4>Limitation of Liability</h4>
      <p>
        To the maximum extent permitted by law, Yoda Safety Services is not
        liable for any direct, indirect, incidental, or consequential damages
        arising from the use of our platform. This includes, but is not limited
        to, loss of data, revenue, or profits, or any other damages resulting
        from errors, interruptions, or inaccuracies in our services.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Liability;
